import { Dialog, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ActionResultPopup extends Component {
   constructor(props) {
      super(props);
   }
  
    // Arrow function automatically binds 'this' to the class instance
   handleClose = () => {
      if (this.props.onClose) {
        this.props.onClose();
      }
   }

  render() {
    const { icon, title, subtitle, description, isOpen } = this.props;

    let subtitleContent;
    if (subtitle){
      if (React.isValidElement(subtitle)) {
        subtitleContent = subtitle;
      } else if (typeof subtitle === 'string') {
        subtitleContent = (
          <Typography variant="h6" className="mt-2">
            {subtitle}
          </Typography>
        );
      }
    }else{
      subtitleContent = null;
    }

    return (
      <Dialog open={isOpen} onClose={this.handleClose} fullWidth maxWidth="sm" disablePortal>
        <DialogContent className="text-left">
          {icon ? icon : null}
          <Typography variant="h5" className="mt-3">
            {title}
          </Typography>
          {subtitleContent}
          {description ? (
            <Typography variant="body1" className="mt-2">
              {description}
            </Typography>
          ) : null}
        </DialogContent>
        <DialogActions style={{ justifyContent: 'right', padding: '1rem 2rem 2rem' }}>
          <Button onClick={this.handleClose} variant="contained" color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ActionResultPopup.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string
  ]),
  description: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

ActionResultPopup.defaultProps = {
  icon: null,
  subtitle: null,
  description: '',
};